const TermOfService = () => {
  return (
    <>
      <div className="explore cv-examples">
        <div className="wrap">
          <div className="terms-of-service">
            <div className="wrap">
              <h1>
                Terms of Service for <a href="https://wowcareer.co/">WoWcareer.co</a>
              </h1>
              <p><strong>Last Updated:</strong> November 14, 2024</p>
              <p>
                Welcome to <a href="https://wowcareer.co/">WoWcareer.co</a> (the "Website"), a service owned and operated by Family Projects Oy. By accessing or using the Website, you agree to comply with and be bound by these Terms of Service ("Terms"). Please read them carefully.
              </p>

              <h2>1. Acceptance of Terms</h2>
              <p>
                By using <a href="https://wowcareer.co/">WoWcareer.co</a>, you agree to these Terms, our Privacy Policy, and any other legal notices, conditions, or guidelines we post on the Website. If you do not agree to these Terms, you may not use the Website.
              </p>

              <h2>2. Services Provided</h2>
              <p>
                <a href="https://wowcareer.co/">WoWcareer.co</a> is a CV/resume and cover letter creation platform, allowing users to input professional and educational information, choose from various templates, and download their documents in PDF format. Access to downloadable templates and the ability to save or export documents is only available to paid subscribers.
              </p>

              <h2>3. Account Registration</h2>
              <p>
                To use our service, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
              </p>

              <h2>4. Subscriptions and Billing</h2>
              <h3>4.1 Subscription Model</h3>
              <p>
                <a href="https://wowcareer.co/">WoWcareer.co</a> operates on a monthly subscription basis. Subscriptions renew automatically every 30 days unless canceled.
              </p>

              <h3>4.2 Trial Period</h3>
              <p>
                The first 14 days of the subscription are offered at a trial price. After the trial period ends, the subscription will renew at the full monthly rate.
              </p>

              <h3>4.3 Payment and Refunds</h3>
              <p>
                Payment is processed at the start of each subscription period. We offer a 14-day money-back guarantee from the start date of your subscription. If you are not satisfied with our service, contact us within 14 days for a full refund.
              </p>

              <h3>4.4 Termination and Cancellations</h3>
              <p>
                You may terminate your subscription or delete your account by logging into your profile, going to the settings page, and selecting either "Terminate Subscription" or "Delete Account." Alternatively, you may contact us at <a href="mailto:support@wowcareer.co">support@wowcareer.co</a> to request termination.
              </p>

              <h2>5. User Responsibilities</h2>
              <p>
                You agree to use <a href="https://wowcareer.co/">WoWcareer.co</a> for lawful purposes only and in a manner consistent with these Terms and applicable laws. You are solely responsible for the content and accuracy of the information you input.
              </p>

              <h2>6. Intellectual Property</h2>
              <p>
                All templates, designs, and other materials provided by <a href="https://wowcareer.co/">WoWcareer.co</a> are the property of Family Projects Oy and are protected by intellectual property laws. You may not copy, distribute, or resell any materials from the Website.
              </p>

              <h2>7. Limitations of Use</h2>
              <p>
                <a href="https://wowcareer.co/">WoWcareer.co</a> reserves the right to suspend or terminate accounts that violate these Terms, misuse the service, or engage in fraudulent activities.
              </p>

              <h2>8. Disclaimer of Warranties</h2>
              <p>
                <a href="https://wowcareer.co/">WoWcareer.co</a> provides its services "as is" and makes no guarantees regarding the accuracy, reliability, or quality of any content generated or downloaded. We disclaim all warranties to the maximum extent permitted by law.
              </p>

              <h2>9. Limitation of Liability</h2>
              <p>
                Family Projects Oy will not be liable for any damages arising out of or related to your use of the Website, including lost revenue, data loss, or indirect damages.
              </p>

              <h2>10. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. Any changes will be posted on this page with an updated effective date. Continued use of the Website after changes implies acceptance of the new Terms.
              </p>

              <h2>11. Contact Us</h2>
              <p>For any questions regarding these Terms, please contact us at:</p>
              <address>
                Family Projects Oy<br />
                Kasavuorentie 18A4, 02700 Kauniainen, Finland<br />
                Email: <a href="mailto:support@wowcareer.co">support@wowcareer.co</a>
              </address>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermOfService;
